/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateLeadDecisionRequestBidirectionalActionDetailsDetails } from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetails';
import {
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped,
    UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON,
} from './UpdateLeadDecisionRequestBidirectionalActionDetailsDetails';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequestBidirectionalActionDetails
 */
export interface UpdateLeadDecisionRequestBidirectionalActionDetails {
    /**
     * 
     * @type {string}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetails
     */
    action: UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum;
    /**
     * 
     * @type {UpdateLeadDecisionRequestBidirectionalActionDetailsDetails}
     * @memberof UpdateLeadDecisionRequestBidirectionalActionDetails
     */
    details?: UpdateLeadDecisionRequestBidirectionalActionDetailsDetails;
}


/**
 * @export
 */
export const UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum = {
    Accept: 'Accept',
    Decline: 'Decline',
    RequestInformation: 'RequestInformation',
    ReferralReceived: 'ReferralReceived'
} as const;
export type UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum = typeof UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum[keyof typeof UpdateLeadDecisionRequestBidirectionalActionDetailsActionEnum];


/**
 * Check if a given object implements the UpdateLeadDecisionRequestBidirectionalActionDetails interface.
 */
export function instanceOfUpdateLeadDecisionRequestBidirectionalActionDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSON(json: any): UpdateLeadDecisionRequestBidirectionalActionDetails {
    return UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequestBidirectionalActionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': json['action'],
        'details': !exists(json, 'details') ? undefined : UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json['details']),
    };
}

export function UpdateLeadDecisionRequestBidirectionalActionDetailsToJSON(value?: UpdateLeadDecisionRequestBidirectionalActionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'details': UpdateLeadDecisionRequestBidirectionalActionDetailsDetailsToJSON(value.details),
    };
}

